import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    author: PropTypes.string,
    content: PropTypes.string
  })
);
